var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dir"},[_c('i',{staticClass:"el-icon-arrow-left",on:{"click":_vm.back}})])}
var staticRenderFns = []

export { render, staticRenderFns }